/**
 * @generated SignedSource<<1aeefdfb2f6feb0458cf0ee538c18131>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamNavigator_storeViewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TeamHeader_storeViewer" | "TeamHomeNavigator_storeViewer">;
  readonly " $fragmentType": "TeamNavigator_storeViewer";
};
export type TeamNavigator_storeViewer$key = {
  readonly " $data"?: TeamNavigator_storeViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamNavigator_storeViewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamNavigator_storeViewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamHeader_storeViewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamHomeNavigator_storeViewer"
    }
  ],
  "type": "StoreViewer",
  "abstractKey": null
};

(node as any).hash = "10775b6877aebe902bacdc89b59406ba";

export default node;
